import formatoReclamacion from "../../../../assets/docs/Formato Reclamación.pdf"
import derechosAsegurado from "../../../../assets/docs/Derechos del asegurado.pdf"

const FormatosGuias = () => {

    const downloadDocumento = (nombreDoc, baseDoc) => {
        const downloadLink = document.createElement("a")
        downloadLink.href = baseDoc
        downloadLink.download = nombreDoc
        downloadLink.click()
    }

    return (
        <>
            <div className="homeout__coberturas m-auto">
                <p className="titulo__guias">Descargables:</p>
                <div className='d-lg-none d-block'><br/></div>
                <div className="div__botones">
                    <button className="btn__azul" onClick={() => downloadDocumento("Formato Reclamación.pdf", formatoReclamacion)}>FORMATO DE RECLAMACIÓN</button>
                    <button className="btn__azul" onClick={() => downloadDocumento("Derechos del asegurado.pdf", derechosAsegurado)}>DERECHOS DEL ASEGURADO</button>
                </div>
            </div>
        </>
    )
}

export default FormatosGuias